var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShieldTick = function SvgShieldTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.905 3.09 9.78 1.547c-.427-.158-1.125-.158-1.552 0L4.103 3.09c-.795.3-1.44 1.23-1.44 2.077v6.075c0 .608.397 1.41.885 1.77l4.125 3.083c.727.547 1.92.547 2.647 0l4.125-3.083c.488-.367.885-1.162.885-1.77V5.168c.008-.847-.637-1.777-1.425-2.077Zm-2.295 4.2-3.225 3.226a.556.556 0 0 1-.397.165.556.556 0 0 1-.398-.165L6.39 9.3a.566.566 0 0 1 0-.795.566.566 0 0 1 .795 0l.81.81 2.828-2.828a.566.566 0 0 1 .795 0 .568.568 0 0 1-.008.803Z",
    fill: "#1877F2"
  })));
};
export default SvgShieldTick;